<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.8648 32.92L26.7982 24.38C26.647 23.1704 26.0591 22.0576 25.1451 21.251C24.2311 20.4444 23.0539 19.9995 21.8348 20H18.1615C16.943 20.0003 15.7666 20.4456 14.8533 21.2521C13.94 22.0587 13.3526 23.1709 13.2015 24.38L12.1331 32.92C12.0745 33.3892 12.1164 33.8655 12.2559 34.3172C12.3955 34.769 12.6296 35.1859 12.9427 35.5403C13.2557 35.8946 13.6406 36.1783 14.0717 36.3725C14.5028 36.5667 14.9703 36.667 15.4431 36.6667H24.5565C25.0292 36.6668 25.4965 36.5663 25.9274 36.372C26.3583 36.1777 26.743 35.894 27.0559 35.5397C27.3687 35.1853 27.6027 34.7685 27.7421 34.3169C27.8816 33.8652 27.9234 33.389 27.8648 32.92V32.92Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 13.334C22.7614 13.334 25 11.0954 25 8.33398C25 5.57256 22.7614 3.33398 20 3.33398C17.2386 3.33398 15 5.57256 15 8.33398C15 11.0954 17.2386 13.334 20 13.334Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66634 18.3327C8.50729 18.3327 9.99967 16.8403 9.99967 14.9993C9.99967 13.1584 8.50729 11.666 6.66634 11.666C4.82539 11.666 3.33301 13.1584 3.33301 14.9993C3.33301 16.8403 4.82539 18.3327 6.66634 18.3327Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.3333 18.3327C35.1743 18.3327 36.6667 16.8403 36.6667 14.9993C36.6667 13.1584 35.1743 11.666 33.3333 11.666C31.4924 11.666 30 13.1584 30 14.9993C30 16.8403 31.4924 18.3327 33.3333 18.3327Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66632 23.334H6.15632C5.36726 23.3339 4.60374 23.6137 4.00161 24.1237C3.39949 24.6336 2.99779 25.3407 2.86799 26.119L2.31299 29.4523C2.23334 29.9299 2.25869 30.4191 2.38727 30.8859C2.51585 31.3527 2.74457 31.7858 3.05753 32.1553C3.37049 32.5247 3.76018 32.8215 4.19948 33.0251C4.63878 33.2286 5.11715 33.334 5.60132 33.334H11.6663"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.333 23.334H33.843C34.6321 23.3339 35.3956 23.6137 35.9977 24.1237C36.5998 24.6336 37.0015 25.3407 37.1313 26.119L37.6863 29.4523C37.766 29.9299 37.7406 30.4191 37.6121 30.8859C37.4835 31.3527 37.2548 31.7858 36.9418 32.1553C36.6288 32.5247 36.2392 32.8215 35.7999 33.0251C35.3606 33.2286 34.8822 33.334 34.398 33.334H28.333"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
